import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import EditablePictureContainer from '~components/generic/editable-picture/EditablePictureContainer';
import { IEntityComponentProps } from '~interfaces/props';
import { convertToRawValue } from '~services/data-conversion';
import { getRelatedEntityIds } from '~services/entity-helpers';

const ModuleExploreBrandsItem = ({
  data,
  uploadFileAction,
  editing,
  onChange,
  isEditing,
  entityDef,
}: IEntityComponentProps) => {
  if (!data) {
    return null;
  }
  const content = data.attributes;
  const imageId = getRelatedEntityIds(data, 'field_image')[0];
  const linkUrl = (content.field_link_external && content.field_link_external.uri) || content.field_link_module;
  const linkText = content.field_link_text || linkUrl;
  return (
    <div className="c-checklist__item o-grid o-grid--wrap o-grid--center relative" id={data.id}>
      <div className="o-grid__cell o-grid__cell--width-3">
        <EditableField
          hide={content.field_hide_title}
          entityType={data.type}
          fieldName="attributes.field_title.value"
          data={content.field_title.value}
          editing={editing}
          onChange={onChange}
        />
      </div>
      <div className="o-grid__cell o-grid__cell--width-6">
        <EditablePictureContainer
          entityType={data.type}
          fieldName="relationships.field_image"
          entityId={imageId}
          editing={editing}
          proportions="8:1"
          onChangeImage={onChange}
          onUpload={uploadFileAction}
          placeholder={
            (isEditing &&
              entityDef &&
              entityDef.fields &&
              entityDef.fields['relationships.field_image'] &&
              entityDef.fields['relationships.field_image'].options?.placeholder) ||
            false
          }
        />
      </div>
      <div className="o-grid__cell o-grid__cell--width-3">
        {linkUrl ? (
          <a href={convertToRawValue(linkUrl)} className="c-button c-button--dark c-button--icon-right">
            {linkText}
            <i className="c-icon-custom c-icon-custom--caret-right" />
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default ModuleExploreBrandsItem;
